module.exports = __webpack_public_path__ + "img/btn_menu_allt.8d467e82.png";